import {configOption, KahunConfigurationOptionType} from "../lib/annotations";

export enum LLMModelType {
    gpt_35_turbo = "gpt-3.5-turbo",
    gpt_4 = "gpt-4",
    anthropic_claude_instant_1 = "claude-instant-1",
    anthropic_claude_2 = "claude-2",
    google_palm_text_bison001 = "text-bison@001",
    gpt_4_turbo = "gpt-4-1106-preview"
}

export class LLMOptions {
    @configOption({
        description: "The LLM Engine to use: gpt, claude etc.",
        options: LLMModelType,
    })
    model?: LLMModelType = LLMModelType.gpt_35_turbo;

    @configOption({
        description: "A custom prompt to use for retreiving the DD, use the macro {{summary}} to position the patient summary in the prompt",
        displayType: KahunConfigurationOptionType.Text,
        displayName: "DD Prompt"
    })
    ddPrompt?: string = "";

    @configOption({
        description: "A custom prompt to use for explaining a disease on the DD list, use the macro {{summary}} and {{diagnosis}} to position the patient summary, and the name of the disease in the prompt ",
        displayType: KahunConfigurationOptionType.Text,
        displayName: "Explanation Prompt"
    })
    explanationPrompt?: string = "";

    @configOption({
        description: "A custom prompt to use for creating a workup text, use the macro {{summary}} and {{dd}}",
        displayType: KahunConfigurationOptionType.Text,
        displayName: "Workup Prompt"
    })
    workupPrompt?: string = "";

    @configOption({
        description: "A custom prompt to use for creating an assessment text, use the macro {{summary}} and {{dd}}",
        displayType: KahunConfigurationOptionType.Text,
        displayName: "Assessment Prompt"
    })
    assessmentPrompt?: string = "";

    @configOption({
        description: "A custom prompt to use for creating medical note",
        displayType: KahunConfigurationOptionType.Text,
        displayName: "Medical Note Prompt"
    })
    medicalNotePrompt?: string = "";

    @configOption({
        description: "max_tokens for DD response",
        displayType: KahunConfigurationOptionType.Int,
        displayName: "DD max_tokens"
    })
    ddMaxTokens?: number = 1500;

    @configOption({
        description: "max_tokens for explanation response",
        displayType: KahunConfigurationOptionType.Int,
        displayName: "Explanation max_tokens"
    })
    explanationtMaxTokens?: number = 600;

    @configOption({
        description: "get clinical reasoning explanation",
        displayName: "Ask for Explanation"
    })
    askForExplanation?: boolean = true;

    @configOption({
        description: "Use formatted Kahun summary as input, false for flat list of findings",
        displayType: KahunConfigurationOptionType.Boolean,
        displayName: "Formatted Summary for LLM Input"
    })
    useKahunSummaryAsInput?: boolean = true;

    @configOption({
        description: "show LLM generated summary sections, not Kahun's internal summary engine",
        displayType: KahunConfigurationOptionType.Boolean,
        displayName: "LLM Generated Summary Sections"
    })
    useLLMGeneratedSummaryOutput?: boolean = false;

    @configOption({
        description: "Use LLM and Kahun KB to ground the generated assessment",
        displayType: KahunConfigurationOptionType.Boolean,
        displayName: "Ask to Ground Assessment"
    })
    groundAssessment?: boolean = false

    @configOption({
        description: "Use LLM and Kahun KB to ground the generated per-disease clinical reasoning explanations",
        displayType: KahunConfigurationOptionType.Boolean,
        displayName: "Ask to Ground Explanations"
    })
    groundExplanation?: boolean = false

    @configOption({
        description: "use LLM to rephrase the summary generated by Kahun templates",
        displayType: KahunConfigurationOptionType.Boolean,
        displayName: "Rephrase Summary"
    })
    rephraseSummary?: boolean = false;

    @configOption({
        description: "Use rag for explanation, assesment and plan ",
        displayType: KahunConfigurationOptionType.Boolean,
        displayName: "Use RAG for LLM outputs"
    })
    useRag?: boolean = false

    @configOption({
        description: "If using rag, which app to use",
        displayType: KahunConfigurationOptionType.String,
        displayName: "RAG App for LLM Outputs"
    })
    ragApp?: string = null

}
